import type { ReactNode } from 'react';
import { cx } from '../../internal/cx.ts';
import { Logo } from '../Logo/Logo.tsx';
import styles from './AuthLayout.module.css';

export type AuthLayoutProps = {
  /** The word under the logo: «Admin», «Negocios». */
  caption?: string;
  children: ReactNode;
  /** Small print under the card. */
  footer?: ReactNode;
  className?: string;
};

/** The «Entrar» screens: dark background, the logo, and a white card in the middle. */
export function AuthLayout({ caption, children, footer, className }: AuthLayoutProps) {
  return (
    <div className={cx(styles.screen, className)}>
      <main className={styles.wrap}>
        <div className={styles.brand}>
          <Logo surface="dark" height={58} />
          {caption ? <span className={styles.caption}>{caption}</span> : null}
        </div>
        <div className={styles.card}>{children}</div>
        {footer ? <p className={styles.footer}>{footer}</p> : null}
      </main>
    </div>
  );
}
